import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TournamentStage } from '../models/tournament-stage';
import { map } from 'rxjs/operators';
import { TournamentGroup } from '../models/tournament-group';
import { Playoff } from '../models/playoff';
import { TournamentStageTeam } from '../models/tournament-stage-team';
import { ConfigService } from '../services/config.service';
import { TeamAchievement } from '../models/team-achievement';

@Injectable({providedIn: 'root'})
export class TournamentStageApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  async getById(id: number): Promise<TournamentStage> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_stage/${id}/`)
      .pipe(map(result => TournamentStage.toFront(result)))
      .toPromise();
  }

  async getGroups(stageId: number): Promise<TournamentGroup[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_stage/${stageId}/groups/`)
      .pipe(map(result => TournamentGroup.toFront(result)))
      .toPromise();
  }

  async getTeamsAchievements(stageId: number): Promise<TeamAchievement[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_stage/${stageId}/achievements/`)
      .pipe(map(result => TeamAchievement.toFront(result)))
      .toPromise();
  }

  async getPlayoffs(stageId: number): Promise<Playoff[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_stage/${stageId}/playoff/`)
      .pipe(map(result => Playoff.toFront(result)))
      .toPromise();
  }

  async getTeams(stageId: number): Promise<TournamentStageTeam[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_stage/${stageId}/teams/`)
      .pipe(map(result => TournamentStageTeam.toFront(result)))
      .toPromise();
  }
}
